import { GiRoundStar } from 'react-icons/gi';
import './Story.css';
import { getIcons } from '../utils/getIcons';
import IconContainer from '../components/IconContainer/IconContainer';

const TreasureHunter = () => {
  const icons = getIcons(['treasure']);

  if (!icons.length) {
    return <div>'NO ICON'</div>;
  }

  return (
    <div className="story-container">
      <div className="story-row">
        1
        <GiRoundStar color="orange" size={15} className="story-star" />
        for each{' '}
        <div className="story-icon-wrapper">
          <IconContainer icon={{ ...icons[0], size: 'sm' }} />
        </div>{' '}
        or 6 <GiRoundStar color="orange" size={15} className="story-star" /> if
        you have at least 3{' '}
        <div className="story-icon-wrapper">
          <IconContainer icon={{ ...icons[0], size: 'sm' }} />
        </div>
      </div>
    </div>
  );
};

export default TreasureHunter;
